// Busca y devuelve el primer elemento que no esté incluido en todos los arreglos
// así como el índice del arreglo que sí lo contiene y el del primero identificado que no lo contiene
export const findNotSharedItem = <T>(...arrays: T[][]): { item: T, containingIndex: number, notContainingIndex: number } | null => {
  for (let i = 0; i < arrays.length; i++) {
    const currentArray = arrays[i];
    for (let j = 0; j < arrays.length; j++)
      if (j !== i)
        for (let k = 0; k < currentArray.length; k++)
          if (!arrays[j].includes(currentArray[k]))
            return { item: currentArray[k], containingIndex: i, notContainingIndex: j };
  }
  return null;
};

// Recibe un arreglo y lo recorta o expande a la longitud deseada
export const fixLength = <T>(array: T[], requiredLength: number): T[] => {
  if (array.length === requiredLength)
    return array;

  if (array.length > requiredLength)
    return array.slice(0, requiredLength);

  const helper = [ ...array ];
  let i = 0;
  for (let j = array.length; j < requiredLength; j++) {
    helper.push(array[i]);
    i = ++i % array.length;
  }
  return helper;
};
